import cloneDeep from 'lodash/cloneDeep';
import {
  doiDefinition,
  isbnDefinition,
  landingPageUrlDefinition,
  referencesDefinition,
  languageCodesDefinition,
  contributorDefinition,
  contributorsDefinition,
  abstractsDefinition,
} from '../common/common-schemas';

const dissertationIsbnDefinition = cloneDeep(isbnDefinition);
dissertationIsbnDefinition.properties.electronicIsbn.i18n =
  'dissertation_electronicIsbn';
dissertationIsbnDefinition.properties.printIsbn.i18n = 'dissertation_printIsbn';

const commonDefinitions = {
  abstracts: abstractsDefinition,
  contributor: contributorDefinition,
  contributors: contributorsDefinition,
  doi: doiDefinition,
  isbn: dissertationIsbnDefinition,
  'crossref_language_codes': languageCodesDefinition,
  landingPageUrl: landingPageUrlDefinition,
  references: referencesDefinition,
};

export const dissertationSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Dissertation Metadata',
  type: 'object',
  required: [
    'title',
    'doi',
    'landingPageUrl',
    'contributors',
    'approvingInstitution',
    'approvalDate',
  ],
  properties: {
    title: {
      type: 'string',
      i18n: 'dissertation_title',
    },
    doi: {
      ...doiDefinition,
      i18n: 'dissertation_doi',
    },
    landingPageUrl: {
      ...landingPageUrlDefinition,
      i18n: 'dissertation_landingPageUrl',
    },
    contributors: {
      $ref: '#/definitions/contributors',
    },
    abstracts: {
      $ref: '#/definitions/abstracts',
    },
    degree: {
      type: 'string',
      i18n: 'dissertation_degree',
    },
    approvingInstitution: {
      type: 'object',
      i18n: 'dissertation_approvingInstitution',
      required: ['institutionName'],
      properties: {
        institutionName: {
          type: 'string',
          i18n: 'dissertation_approvingInstitution_institutionName',
          'x-rorIdField': 'rorId',
        },
        rorId: {
          type: 'string',
          i18n: 'dissertation_approvingInstitution_rorId',
        },
      },
    },
    approvalDate: {
      type: 'string',
      format: 'date',
      i18n: 'dissertation_approvalDate',
    },
    isbn: {
      $ref: '#/definitions/isbn',
    },
    daiIdentifier: {
      type: 'string',
      maxLength: 255,
      i18n: 'dissertation_daiIdentifier',
    },
    references: {
      $ref: '#/definitions/references',
    },
  },
  definitions: {
    ...commonDefinitions,
  },
};

export const dissertationRecordSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Dissertation',
  type: 'object',
  required: ['dissertationMetadata'],
  properties: {
    dissertationMetadata: dissertationSchema,
  },
  definitions: {
    ...commonDefinitions,
  },
};
